module.exports = __webpack_public_path__ + "static/media/English - Teaching - Road to Enlightenment (load_1) - translated by JL.b0d9eb48.txt";